import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1317e30d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "LocalHighlight" }
const _hoisted_2 = ["src"]

import { onMounted, nextTick, reactive } from 'vue'
import { isD2C } from '@/store'
import Popover from './Popover.vue'


export default /*#__PURE__*/_defineComponent({
  props: {
  // 选择区域模式 element-寻找元素 anchor-元素锚点定位 free-自由框选
  mode: {
    type: String,
    default: 'element'
  },
  // 边距（圆角）
  padding: {
    type: Number,
    default: 35
  },
  // 关闭组件
  onClose: {
    type: Function,
    default: null
  },
  // 分布引导-当前index
  curStep: {
    type: Number,
    default: 0
  },
  // 分布引导-总数
  totalStep: {
    type: Number,
    default: 0
  },
  // 操作分步引导
  handleStep: {
    type: Function,
    default: null
  },
  // 是否允许点击遮罩关闭
  allowClose: {
    type: Boolean,
    default: false
  },
  offsetTop: {
    type: Number,
    default: 0
  },
  offsetLeft: {
    type: Number,
    default: 0
  },
  boxWidth: {
    type: Number,
    default: 0
  },
  boxHeight: {
    type: Number,
    default: 0
  },
  imgUrl: {
    type: String,
    default: null
  },
  imgRightDistance: {
    type: Number,
    default: 0
  },
  popover: {
    type: Object,
    default: null
  },
  iconWidth: {
    type: Number,
    default: 72
  },
  isSkip: {
    type: Boolean,
    default: true
  },
  // 元素 左边 阴影偏移量
  boxCutLeft: {
    type: Number,
    default: 0
  },
  // 元素 右边 阴影偏移量
  boxCutRight: {
    type: Number,
    default: 0
  },
  // 元素 顶部 阴影偏移量
  boxCutTop: {
    type: Number,
    default: 0
  },
  // 元素 顶部 阴影偏移量
  boxCutBottom: {
    type: Number,
    default: 0
  },
  // 弹窗left
  modalLeft: {
    type: Number,
    default: 0
  },
  // 弹窗距离 顶部 距离
  modalTop: {
    type: Number,
    default: 0
  }
},
  setup(__props) {

const props = __props
const shadowColor = 'rgba(0, 0, 0, 0.6)'

onMounted(() => {
  // nextTick(() => {
  //   const dom: any = document.querySelector('.LocalHighlight-main')?.getBoundingClientRect()
  //   data.width = dom.width
  //   data.height = dom.height
  // })
})



const data = reactive({
  width: 0,
  height: 0
})

// onMounted(() => {
//   setTimeout(() => {
//     console.log(12)
//     console.log(document.getElementById('test'))
//   }, 3000)
// })

// 点击遮罩
const handleShadow = () => {
  if (props.allowClose) {
    props.onClose()
  }
  // props.onClose()
  // props.handleStep(1)
}

// 下一步
const next = () => {
  console.log('next')
  props.onClose()
  props.handleStep('next', props.curStep + 1)
}

// 跳过
const skip = () => {
  props.onClose()
  props.handleStep('skip')
}

// 点击main
const handleMain = () => {
  if (props.curStep + 1 === props.totalStep) {
    skip()
  } else {
    next()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "LocalHighlight-shadow top",
      style: _normalizeStyle({
      bottom: `calc(100vh - ${__props.offsetTop - __props.padding + __props.boxCutTop}px)`
    }),
      onClick: handleShadow
    }, null, 4),
    _createElementVNode("div", {
      class: "LocalHighlight-shadow left",
      style: _normalizeStyle({
      top: `${__props.offsetTop - __props.padding + __props.boxCutTop}px`,
      right: `calc(100vw - ${__props.offsetLeft - __props.padding + __props.boxCutLeft}px)`,
      bottom: `calc(100vh - (${__props.offsetTop - __props.boxCutBottom}px + ${__props.boxHeight + __props.padding}px))`
    }),
      onClick: handleShadow
    }, null, 4),
    _createElementVNode("div", {
      class: "LocalHighlight-shadow right",
      style: _normalizeStyle({
      top: `${__props.offsetTop - __props.padding + __props.boxCutTop}px`,
      left: `calc(${__props.offsetLeft - __props.boxCutRight}px + ${__props.boxWidth + __props.padding}px)`,
      bottom: `calc(100vh - (${__props.offsetTop - __props.boxCutBottom}px + ${__props.boxHeight + __props.padding}px))`
    }),
      onClick: handleShadow
    }, null, 4),
    _createElementVNode("div", {
      class: "LocalHighlight-shadow bottom",
      style: _normalizeStyle({
      top: `calc(${__props.offsetTop - __props.boxCutBottom}px + ${__props.boxHeight + __props.padding}px)`
    }),
      onClick: handleShadow
    }, null, 4),
    _createElementVNode("div", {
      class: "LocalHighlight-main",
      style: _normalizeStyle({
      top: `${__props.offsetTop - __props.padding + __props.boxCutTop}px`,
      left: `${__props.offsetLeft - __props.padding + __props.boxCutLeft}px`,
      right: `calc(100vw - ${__props.offsetLeft - __props.boxCutRight}px - ${__props.boxWidth + __props.padding}px)`,
      bottom: `calc(100vh - (${__props.offsetTop - __props.boxCutBottom}px + ${__props.boxHeight + __props.padding}px))`,
      padding: `${__props.padding}px`
    })
    }, [
      _createElementVNode("div", {
        class: "LocalHighlight-main-radius tl",
        style: _normalizeStyle({
        width: `${__props.padding}px`,
        height: `${__props.padding}px`,
        'background-image': `radial-gradient(circle ${__props.padding}px at 100% 100%,  transparent ${__props.padding}px, ${shadowColor} 103%)`
      })
      }, null, 4),
      _createElementVNode("div", {
        class: "LocalHighlight-main-radius tr",
        style: _normalizeStyle({
        width: `${__props.padding}px`,
        height: `${__props.padding}px`,
        'background-image': `radial-gradient(circle ${__props.padding}px at 0 100%,  transparent ${__props.padding}px, ${shadowColor} 103%)`
      })
      }, null, 4),
      _createElementVNode("div", {
        class: "LocalHighlight-main-radius bl",
        style: _normalizeStyle({
        width: `${__props.padding}px`,
        height: `${__props.padding}px`,
        'background-image': `radial-gradient(circle ${__props.padding}px at 100% 0,  transparent ${__props.padding}px, ${shadowColor} 103%)`
      })
      }, null, 4),
      _createElementVNode("div", {
        class: "LocalHighlight-main-radius br",
        style: _normalizeStyle({
        width: `${__props.padding}px`,
        height: `${__props.padding}px`,
        'background-image': `radial-gradient(circle ${__props.padding}px at 0 0, transparent ${__props.padding}px, ${shadowColor} 103%)`
      })
      }, null, 4),
      (__props.popover)
        ? (_openBlock(), _createBlock(Popover, {
            key: 0,
            description: __props.popover?.description,
            position: __props.popover?.position,
            popoverWidth: __props.popover?.popoverWidth,
            offsetX: __props.popover?.offsetX,
            offsetY: __props.popover?.offsetY,
            curStep: __props.curStep,
            totalStep: __props.totalStep,
            isSkip: __props.isSkip,
            onNext: next,
            onSkip: skip,
            modalLeft: __props.modalLeft,
            modalTop: __props.modalTop
          }, null, 8, ["description", "position", "popoverWidth", "offsetX", "offsetY", "curStep", "totalStep", "isSkip", "modalLeft", "modalTop"]))
        : _createCommentVNode("", true)
    ], 4),
    (__props.imgUrl)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "LocalHighlight-img",
          style: _normalizeStyle({
      top: `${__props.offsetTop}px`,
      left: `${__props.offsetLeft}px`,
      right: `calc(${__props.imgRightDistance}px)`
    })
        }, [
          _createElementVNode("img", {
            referrerPolicy: "no-referrer",
            src: __props.imgUrl
          }, null, 8, _hoisted_2)
        ], 4))
      : _createCommentVNode("", true)
  ]))
}
}

})